import { apiClient } from '@/config/api';

export interface AlertBoxOfflineConfig {
  emails: string[];
}

export interface HeatingSetpointConfig {
  value: number | null;
}

export const configService = {
  /**
   * Get alert box offline mail configuration
   */
  async getAlertBoxOfflineMail(): Promise<AlertBoxOfflineConfig> {
    const res = await apiClient.get<AlertBoxOfflineConfig>('/config/alert-box-offline-mail');
    return res.data;
  },

  /**
   * Update alert box offline mail configuration
   */
  async updateAlertBoxOfflineMail(emails: string[]): Promise<AlertBoxOfflineConfig & { success: boolean; message: string }> {
    const res = await apiClient.put<AlertBoxOfflineConfig & { success: boolean; message: string; errors?: any[] }>(
      '/config/alert-box-offline-mail',
      { emails }
    );
    return res.data;
  },

  /**
   * Get heating setpoint configuration
   */
  async getHeatingSetpoint(): Promise<HeatingSetpointConfig> {
    const res = await apiClient.get<HeatingSetpointConfig>('/config/heating-setpoint');
    return res.data;
  },

  /**
   * Update heating setpoint configuration
   */
  async updateHeatingSetpoint(value: number | null): Promise<HeatingSetpointConfig & { success: boolean; message: string }> {
    const res = await apiClient.put<HeatingSetpointConfig & { success: boolean; message: string }>(
      '/config/heating-setpoint',
      { value }
    );
    return res.data;
  },
};
